import React from "react";
import Col from "react-bootstrap/Col";
// import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
// import RichTextPageContent from "@components/RichTextPageContent";
// import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
// import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import GeneralRichText from "components/Reusables/GeneralRichText";
import Image from "components/Reusables/Image";
import { colors } from "@utils/styles";

export default function Author(props) {
	return (
		<section className="mt-3 authors radius-5px px-4 py-1">
			{props.authors.map((author, index) => (
				<div className="author row  d-flex align-items-start my-3" key={author.sys.id}>
					<span className="name">{author.fields.name}</span>

					<Col className="justify-content-center d-flex " xs="auto">
						{author?.fields?.photo?.fields && (
							<Image
								fields={{ media: { fields: author.fields.photo.fields } }}
								extraClass="round"
								width={75}
							/>
						)}
					</Col>
					<Col>
						<div className="info">
							<span className="bio">
								<GeneralRichText content={author.fields.bio} />
							</span>
						</div>
					</Col>
					{index !== props.authors.length - 1 && <hr />}
				</div>
			))}
			<style jsx="true">{`
				hr {
					margin-top: 20px;
				}
				.authors {
					border: 1px solid ${colors.darkGray};
				}
				.author {
					display: flex;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
				}
				.info {
					display: flex;
					flex-direction: column;
					justify-content: center;
				}
				.name {
					font-weight: bold;
					font-size: 14px;
					margin-bottom: 10px;
				}
				.bio {
					font-size: 14px !important;
				}
				img {
					border-radius: 50%;
					margin: 16px;
				}
			`}</style>
		</section>
	);
}
